"use strict";
// config
Object.defineProperty(exports, "__esModule", { value: true });
var app = angular.module('callX')
    .config(['$controllerProvider', '$compileProvider', '$filterProvider', '$provide', '$httpProvider', '$authProvider',
    function ($controllerProvider, $compileProvider, $filterProvider, $provide, $httpProvider, $authProvider) {
        // lazy controller, directive and service
        app.controller = $controllerProvider.register;
        app.directive = $compileProvider.directive;
        app.filter = $filterProvider.register;
        app.factory = $provide.factory;
        app.service = $provide.service;
        app.constant = $provide.constant;
        app.value = $provide.value;
        $authProvider.google({
            clientId: '902398246905-chkerij6h7ukd7bfpbt2ljlq2sbd0rle.apps.googleusercontent.com',
            redirectUri: 'http://127.0.0.1',
            scope: 'https://www.googleapis.com/auth/adwords',
            requiredUrlParams: ['scope', 'approval_prompt', 'access_type'],
            accessType: 'offline',
            approvalPrompt: 'force',
            responseType: 'code'
        });
    }
    //https://publisher.callx.com/?code=7dc697dca3b89fbaf3f32cc0c11f1a0e#/access/login
]);
// .config(function ($routeProvider) {
//       $routeProvider
//         .when('?code=:code', {
//           template: '',
//           controller: function ($location,$rootScope) {
//             var hash = $location.path().substr(1);
//            var splitted = hash.split('&');
//            var params = {};
//            for (var i = 0; i < splitted.length; i++) {
//              var param  = splitted[i].split('=');
//              var key    = param[0];
//              var value  = param[1];
//              params[key] = value;
//              $rootScope.accesstoken=params;
//              console.log($rootScope.accesstoken,"rootScope.accesstoken this")
//            }
//            $location.path("/app/dashboard");
//          }
//        })
//    });
